module.exports = __webpack_public_path__ + "img/newsImg12-12.6aabd237.png";